import { GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function verifyLogin(usuario, contrasenia) {
  try {
    let data = null;
    const { code, body, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apichecklistv2/api/autenticacion/login-web",
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ usuario, contrasenia }),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data = body;
    } else {
      data = {};
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("login err");
    console.log(err);
    return null;
  }
}

export async function getUserInfo() {
  try {
    let data = null;
    const { code, body, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apichecklistv2/api/autenticacion/user-info",
      {
        headers: getHeaders(),
        method: "POST",
        body: JSON.stringify({}),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data = body;
    }
    return data;
  } catch (err) {
    console.log("getUserInfo err");
    console.log(err);
    return null;
  }
}

export async function obtenerInfoUsuario() {
  try {
    let data = null;
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apichecklistv2/api/autenticacion/obtener-info-usuario",
      {
        headers: getHeaders(),
        method: GET,
        // body: JSON.stringify({}),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      if (Array.isArray(body) && body.length > 0) {
        data = body[0];
      }
    }
    return data;
  } catch (err) {
    console.log("obtenerInfoUsuario err");
    console.log(err);
    return null;
  }
}